export default __webpack_public_path__ + "static/media/e-met-picturemark-d.4e67121c.svg";